import CryptoJS from 'crypto-js';

/** 线上用 7CN7iz9sU6Bq8fmu，测试和本地用 xdCcpF33CPzYWG1r */
const saltKey =
  process.env.VUE_APP_ENV === 'test' || process.env.VUE_APP_ENV === 'development'
    ? 'xdCcpF33CPzYWG1r'
    : '7CN7iz9sU6Bq8fmu';

// 加密
export const encryptTT = (data: string): string => {
  const keyHex = CryptoJS.enc.Utf8.parse(saltKey);
  const encrypted = CryptoJS.AES.encrypt(data, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.ciphertext.toString().toUpperCase();
};
